module.exports = __webpack_public_path__ + "static/media/refreshLoading.e19a8b77.svg";